import React, { useState } from 'react';
import { Tab, Tabs, Form, Button, Image, Spinner, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCodePostalsAll } from '../../../actions/request/CodePostalRequest';
import { useEffect } from 'react';
import { UserCreate, UserUpdateById } from '../../../actions/request/UserRequest';
import { toast } from 'react-toastify';
import Select from "react-select";
import { getAndCheckLocalStorage } from '../../../utils/storage/localvalueFuction';
import { localStorageKeys } from '../../../utils/storage/localvalue';
import { FETCH_CUSTOMERS_REQUEST, FETCH_CUSTOMER_FAILURE, FETCH_CUSTOMER_REQUEST, FETCH_CUSTOMER_SUCCESS, FETCH_USER_FAILURE, FETCH_USER_REQUEST, FETCH_USER_SUCCESS } from '../../../app/actions/actions';
import axios from 'axios';
import { baseurl } from '../../../utils/url/baseurl';
import { handleImageUploadCloudOnly } from '../../../actions/upload/UploadFileCloud';
import { maxLengthLitte, maxLengthLitteStart, profileRoleType } from '../../../utils/dataApi/dataFormApi';
import { CustomerUpdateById } from '../../../actions/request/CustomerRequest';


function ProfileAccount() {
    const [key, setKey] = useState('profile');
    const dispatch = useDispatch();
    const loadingUser = useSelector((state) => state.users.loadingUser);
    const codepostals = useSelector((state) => state.codepostals.codepostals);

    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        companyName: '',
        phone: '',
        codePostal: '',
        gender: 'Male',
        dateOfBirth: '',
        profilePicture: '',
        profession: '',
        address: '',
        addressPostal: '',
        numberTVA: '',
        role: 'SUPER_ADMIN',
        description: '',
        location: '',
        bankInfos: [ // Nouveau champ pour les informations bancaires
            {
                bankAccountNumber: '', // Numéro de compte bancaire
                bankName: '',          // Nom de la banque
                iban: '',              // IBAN
                swiftCode: '',
            },
        ],
    });


    const addBankInfo = () => {
        setFormData((prevData) => ({
            ...prevData,
            bankInfos: [
                ...prevData.bankInfos,
                { bankAccountNumber: '', bankName: '', iban: '', swiftCode: '' }, // Nouveau compte vide
            ],
        }));
    };

    const removeBankInfo = (index) => {
        if (formData.bankInfos.length > 1) {
            const updatedBankInfos = formData.bankInfos.filter((_, i) => i !== index);
            setFormData((prevData) => ({
                ...prevData,
                bankInfos: updatedBankInfos,
            }));
        } else {
            toast.error("Vous devez conserver au moins un compte bancaire.", { position: "bottom-right" });
        }
    };

    const handleBankInfoChange = (index, field, value) => {
        const updatedBankInfos = [...formData.bankInfos];
        updatedBankInfos[index][field] = value;
        setFormData((prevData) => ({
            ...prevData,
            bankInfos: updatedBankInfos,
        }));
    };






    function fetchUserByGet() {
        return async (dispatch) => {
            dispatch({ type: FETCH_USER_REQUEST });
            dispatch({ type: FETCH_CUSTOMER_REQUEST });
            await axios.get(
                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ?
                    `${baseurl.url}/api/v1/users/get_user/${getAndCheckLocalStorage(localStorageKeys.userId)}`
                    :
                    `${baseurl.url}/api/v1/customers/get_customer/${getAndCheckLocalStorage(localStorageKeys.userId)}`

                , {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }).then((response) => {
                    console.log(response.data.data);
                    const responseData = response.data.data;
                    dispatch({ type: FETCH_USER_SUCCESS, payload: response.data.data });
                    dispatch({ type: FETCH_CUSTOMER_SUCCESS, payload: response.data.data });
                    setFormData(
                        {...formData,
                            firstname: responseData.firstname,
                            lastname: responseData.lastname,
                            companyName: responseData.companyName,
                            phone: responseData.phone,
                            codePostal: responseData.codePostal,
                            gender: responseData.gender,
                            dateOfBirth: responseData.dateOfBirth,
                            profilePicture: responseData.profilePicture,
                            profession: responseData.profession,
                            address: responseData.address,
                            addressPostal: responseData.addressPostal,
                            numberTVA: responseData.numberTVA,
                            role: responseData.role,
                            description: responseData.description,
                            location: responseData.location,
                            bankInfos: responseData?.bankInfos,
                        }
                    )
                })
                .catch((error) => {
                    dispatch({ type: FETCH_USER_FAILURE, payload: error.message })
                    dispatch({ type: FETCH_CUSTOMER_FAILURE, payload: error.message })
                    console.log(error);
                });
        }
    }


    const handleFileChange = async (event) => {
        const file = event.target.files[0]; // Récupère le premier fichier sélectionné

        // 1. Vérifier si un fichier a été sélectionné
        if (!file) {
            toast.error("Aucun fichier sélectionné.", { position: "bottom-right" });
            return;
        }

        // 2. Vérifier si le fichier est une image (type MIME)
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
            toast.error("Le fichier sélectionné n'est pas une image.", { position: "bottom-right" });
            return;
        }

        try {
            // 3. Télécharger le fichier sur le cloud ou le traiter
            const url = await handleImageUploadCloudOnly(file);

            // 4. Vérifier que l'URL a bien été générée
            if (url) {
                setFormData({ ...formData, profilePicture: url });
                // toast.error("Fichier téléchargé avec succès ", { position: "bottom-right" });
            } else {
                toast.error("Échec du téléchargement du fichier.", { position: "bottom-right" });
            }
        } catch (error) {
            toast.error("Erreur lors du traitement du fichier :", { position: "bottom-right" });
        }
    };




    useEffect(() => {
        // Fetch codePostals and companies from API
        dispatch(fetchCodePostalsAll());
        dispatch(fetchUserByGet());
    }, [dispatch]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Limiter la longueur à 100 caractères
        if (value.length <= maxLengthLitte) {
            setFormData({
                ...formData,
                [name]: value,
            });
        } else {
            console.warn("La valeur ne peut pas dépasser 100 caractères.");
        }
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData({
            ...formData,
            [name]: selectedOption ? selectedOption.value : '',
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Submit logic here
        if (
            !formData.firstname ||
            !formData.lastname ||
            !formData.codePostal ||
            !formData.phone
        ) {
            toast.error("Champs avec * non requis", { position: "bottom-right" })
        }
        if (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER) {
            dispatch(UserUpdateById(getAndCheckLocalStorage(localStorageKeys.userId), formData, toast))
        } else {
            dispatch(CustomerUpdateById(getAndCheckLocalStorage(localStorageKeys.userId), formData, toast))
        }

    };

    // Prepare options for react-select
    const codePostalOptions = codepostals.map((code) => ({
        value: code._id,
        label: `${code.indicatif} - ${code.country}`,
    }));

    const genderOptions = [
        { value: 'Male', label: 'Homme' },
        { value: 'Female', label: 'Femme' },
    ];

    const roleOptions = [
        { value: 'INDIVIDUAL', label: 'Individu' },
        { value: 'COMPANY', label: 'Entreprise' },
        { value: 'ADMIN', label: 'Administrateur' },
        { value: 'SUPER_ADMIN', label: 'Super Administrateur' },
    ];

    return (

        <div className="border shadow-sm rounded-lg p-5">
            <Form onSubmit={handleSubmit}>
                {loadingUser ? (
                    <div className="text-center" style={{ height: "500px" }}>
                        <Spinner animation="border" variant="primary" />
                        <p>Chargement en cours...</p>
                    </div>
                ) : (
                    <>
                        <div className="row">

                            <div className="col-md-4 form-group">
                                <label>Nom *</label>
                                <input style={{ height: "40px" }}
                                    type="text"
                                    className="form-control"
                                    name="lastname"
                                    value={formData.lastname}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-md-4 form-group">
                                <label>Prénom *</label>
                                <input style={{ height: "40px" }}
                                    type="text"
                                    className="form-control"
                                    name="firstname"
                                    value={formData.firstname}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            
                            <div className="col-md-4 form-group">
                                <label>Agence / Entreprise </label>
                                <input style={{ height: "40px" }}
                                    type="text"
                                    className="form-control"
                                    name="companyName"
                                    value={formData.companyName}
                                    onChange={handleChange}
                                    disabled={getAndCheckLocalStorage(localStorageKeys.profileRole) === profileRoleType.USER &&
                                        (
                                          !getAndCheckLocalStorage(localStorageKeys.RoleSubAccountName) || // Pas de sous-rôle
                                          getAndCheckLocalStorage(localStorageKeys.RoleSubAccountName) !== profileRoleType.HOME || // Sous-rôle est HOME
                                          getAndCheckLocalStorage(localStorageKeys.RoleSubAccountName) !== profileRoleType.DRIVER // Sous-rôle n'est pas DRIVER
                                        ) ? false:true}
                                />
                            </div>

                            <div className=" col-md-6 form-group">
                                <label>Téléphone *</label>
                                <input style={{ height: "40px" }}
                                    type="number"
                                    className="form-control"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className=" col-md-6 form-group">
                                <label>Indicatif (téléphone ) * </label>
                                <Select
                                    required
                                    name="codePostal"
                                    isClearable
                                    options={codePostalOptions}
                                    onChange={handleSelectChange}
                                    value={codePostalOptions.find(option => option.value === formData.codePostal)}
                                    placeholder="Sélectionner un code postal"
                                />
                            </div>
                            {/*<div className=" col-md-4 form-group">
                                <label>Genre * </label>
                                <Select
                                required
                                    name="gender"
                                    isClearable
                                    options={genderOptions}
                                    onChange={handleSelectChange}
                                    value={genderOptions.find(option => option.value === formData.gender)}
                                    placeholder="Sélectionner un genre"
                                />
                            </div> */}
                            {/*<div className="col-md-6 form-group">
                                <label>Date de naissance * </label>
                                <input style={{ height: "40px" }}
                                    type="date"
                                    className="form-control"
                                    name="dateOfBirth"
                                    value={formData.dateOfBirth}
                                    onChange={handleChange}
                                    required
                                />
                            </div> */}

                            <div className="col-md-6 form-group">
                                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                                    <div>
                                        <label>Photo de profil:</label>
                                        <input
                                            style={{ height: "40px" }}
                                            type="file" accept=".jpg,.png,.jpeg"
                                            className="form-control"
                                            name="profilePicture"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                    <div>
                                        <Image src={formData.profilePicture} className="rounded-lg" style={{ height: "50px", width: "50px" }} />
                                    </div>
                                </div>
                            </div>
                            <div className=" col-md-6 form-group">
                                <label>Profession:</label>
                                <input style={{ height: "40px" }}
                                    type="text"
                                    className="form-control"
                                    name="profession"
                                    value={formData.profession}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 form-group">
                                <label>Adresse Précise</label>
                                <input
                                    style={{ height: "40px" }}
                                    type="text"
                                    className="form-control"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 form-group">
                                <label>Adresse postale </label>
                                <input style={{ height: "40px" }}
                                    type="text"
                                    className="form-control"
                                    name="addressPostal"
                                    value={formData.addressPostal}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-12 form-group">
                                <label>Numéro de TVA:</label>
                                <input style={{ height: "40px" }}
                                    type="text"
                                    className="form-control"
                                    name="numberTVA"
                                    value={formData.numberTVA}
                                    onChange={handleChange}
                                />
                            </div>


                            {/*<div className="col-md-4 form-group">
                                <label>Rôle:</label>
                                <Select
                                    name="role"
                                    isClearable
                                    options={roleOptions}
                                    onChange={handleSelectChange}
                                    value={roleOptions.find(option => option.value === formData.role)}
                                    placeholder="Sélectionner un rôle"
                                />
                            </div>*/}

                            {
                                /*<div className="col-md-4 form-group">
                                <label>Emplacement:</label>
                                <input style={{ height: "40px" }}
                                    type="text"
                                    className="form-control"
                                    name="location"
                                    value={formData.location}
                                    onChange={handleChange}
                                />
                            </div> */
                            }

                            {
                                !getAndCheckLocalStorage(localStorageKeys.ParentSubAcount) &&(
                                    getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER
                                ) &&(
                                    <div className="col-md-12 ">
                                    <h4>Informations Bancaires</h4>
                                    {formData.bankInfos.map((info, index) => (
                                        <div key={index} className="border-b pb-2" style={{ width: "100%", marginBottom: "20px" }}>
                                            <h5>Compte Bancaire N°{index + 1}</h5>
                                            <Row>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Numéro de Compte :</Form.Label>
                                                        <Form.Control
                                                            style={{ height: "40px" }}
                                                            type="text"
                                                            value={info.bankAccountNumber}
                                                            onChange={(e) =>
                                                                handleBankInfoChange(index, "bankAccountNumber", e.target.value)
                                                            }
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Nom de la Banque :</Form.Label>
                                                        <Form.Control
                                                            style={{ height: "40px" }}
                                                            type="text"
                                                            value={info.bankName}
                                                            onChange={(e) =>
                                                                handleBankInfoChange(index, "bankName", e.target.value)
                                                            }
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>IBAN :</Form.Label>
                                                        <Form.Control
                                                            style={{ height: "40px" }}
                                                            type="text"
                                                            value={info.iban}
                                                            onChange={(e) =>
                                                                handleBankInfoChange(index, "iban", e.target.value)
                                                            }
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Code swift (Facultaif)</Form.Label>
                                                        <Form.Control
                                                            style={{ height: "40px" }}
                                                            type="text"
                                                            value={info.swiftCode}
                                                            onChange={(e) =>
                                                                handleBankInfoChange(index, "swiftCode", e.target.value)
                                                            }
                                                            required
                                                        />
                                                    </Form.Group>
                                                </Col>
    
    
    
    
                                                {formData.bankInfos.length > 1 && (
                                                    <div><Button variant="danger" size="sm" onClick={() => removeBankInfo(index)}>
                                                        Supprimer
                                                    </Button>
                                                    </div>
                                                )}
                                            </Row>
                                        </div>
                                    ))}
                                    <div>
                                        <Button variant="primary" size='sm' onClick={addBankInfo}>
                                            + Ajouter
                                        </Button>
                                    </div>
                                </div>
                                )
                            }
                            


                            <div className="col-md-12 form-group mt-4">
                                <label>Description:</label>
                                <textarea
                                    className="form-control"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                ></textarea>
                            </div>

                        </div>
                        <hr className="my-5" />
                        <button type="submit" className="btn  btn-sm btn-primary mt-5">Enregistrer</button>
                    </>
                )}
            </Form>
        </div>
    );
}

export default ProfileAccount;
